import { render } from "./CurrentContract.vue?vue&type=template&id=07d20dec"
import script from "./CurrentContract.vue?vue&type=script&lang=js"
export * from "./CurrentContract.vue?vue&type=script&lang=js"

import "./CurrentContract.vue?vue&type=style&index=0&id=07d20dec&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__